import Component from 'navigation/component/Component';
import './SearchSuggestions.scss'

export default class SearchSuggestions extends Component {}
